import { LocationFilterModel, LocationModel } from '@core/models/location.model';
import { CreatedLocation } from '../locations/components/location-dialog/location-dialog.component';

const LOOKUP_LIMIT = 10;

const squashed = (value: string | null | undefined): string =>
  (value ?? '').replace(/\s+/g, '').toLowerCase();

// Creating a location answers with no body, so the new one is found again by the address that was
// sent. The service stores the postal code without spaces.
export function createdLocationFilter({
  partnerOid,
  postalCode,
  streetNumber,
  streetNumberAddition,
}: CreatedLocation): LocationFilterModel {
  const addition = streetNumberAddition.trim();
  return {
    partnerOid,
    zipCode: postalCode.replace(/\s+/g, ''),
    streetNumber: String(streetNumber),
    ...(addition ? { streetNumberAddition: addition } : {}),
    limit: LOOKUP_LIMIT,
    offset: 0,
  };
}

// The filter may be looser than the address, so only the row that matches on every part counts.
export function findCreatedLocation(
  rows: LocationModel[],
  created: CreatedLocation,
): LocationModel | undefined {
  return rows.find(
    row =>
      row.partnerOid?.toLowerCase() === created.partnerOid.toLowerCase() &&
      squashed(row.locationPostalCode) === squashed(created.postalCode) &&
      row.locationStreetNumber === created.streetNumber &&
      squashed(row.locationStreetNumberAddition) === squashed(created.streetNumberAddition),
  );
}
